<template>
  <div>
    <template v-if="isLoading">
      <!-- loading -->
      <div>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 200 200"
          class="size-20 text-secondary mx-auto"
        >
          <circle
            fill="currentColor"
            stroke="currentColor"
            stroke-width="15"
            r="15"
            cx="40"
            cy="100"
          >
            <animate
              attributeName="opacity"
              calcMode="spline"
              dur="2"
              values="1;0;1;"
              keySplines=".5 0 .5 1;.5 0 .5 1"
              repeatCount="indefinite"
              begin="-.4"
            ></animate>
          </circle>
          <circle
            fill="currentColor"
            stroke="currentColor"
            stroke-width="15"
            r="15"
            cx="100"
            cy="100"
          >
            <animate
              attributeName="opacity"
              calcMode="spline"
              dur="2"
              values="1;0;1;"
              keySplines=".5 0 .5 1;.5 0 .5 1"
              repeatCount="indefinite"
              begin="-.2"
            ></animate>
          </circle>
          <circle
            fill="currentColor"
            stroke="currentColor"
            stroke-width="15"
            r="15"
            cx="160"
            cy="100"
          >
            <animate
              attributeName="opacity"
              calcMode="spline"
              dur="2"
              values="1;0;1;"
              keySplines=".5 0 .5 1;.5 0 .5 1"
              repeatCount="indefinite"
              begin="0"
            ></animate>
          </circle>
        </svg>
      </div>
    </template>
    <template v-else>
      <!-- no documents -->
      <p class="text-center" v-if="!documents.length">
        Dokumenty nejsou k dispozici.
      </p>
      <!-- documents list -->
      <div class="flex flex-col gap-5" v-else>
        <!-- document link -->
        <a
          v-for="(document, index) in documents"
          :key="index"
          :href="document.url"
          target="_blank"
          :title="document.name"
          class="group btn btn-secondary-light flex items-center gap-4 hover:shadow focus:shadow"
        >
          <svg class="shrink-0 size-10">
            <use :xlink:href="getDocumentIcon(document)"></use>
          </svg>
          <span class="font-semibold font-galano truncate">
            {{ document.name }}
          </span>
          <svg
            class="shrink-0 size-5 ms-auto transition group-hover:translate-x-1"
          >
            <use xlink:href="/assets/static/icons.svg#chevron-right"></use>
          </svg>
        </a>
      </div>
    </template>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'

type InvestorsDocument = {
  url: string
  name: string
}

const isLoading = ref<boolean>(true)
const documents = ref<InvestorsDocument[]>([])

onMounted(() => {
  fetchDocuments()
})

const fetchDocuments = () => {
  fetch('/api/investor-documents')
    .then(response =>
      response.ok ? response.json() : Promise.reject(response)
    )
    .then(docs => {
      if (!Array.isArray(docs) || docs.length === 0) {
        return
      }

      documents.value = docs
    })
    .finally(() => {
      isLoading.value = false
    })
}

const getDocumentIcon = (document: InvestorsDocument) =>
  `/assets/static/icons.svg#${document.url.startsWith('/') ? 'pdf' : 'link'}`
</script>

<style scoped></style>
